// StatTable.js — a compact numeric table (first column left-aligned, the rest
// right-aligned, tabular figures) that scrolls sideways on narrow screens.
// Used by the club pages.

import React from "react";
import { Box } from "@mui/material";
import { BRAND } from "../theme";

export default function StatTable({ head, rows }) {
  return (
    <Box sx={{ overflowX: "auto", mb: 2 }}>
      <Box
        component="table"
        sx={{
          width: "100%",
          minWidth: head.length > 5 ? 520 : 0,
          borderCollapse: "collapse",
          fontFeatureSettings: '"tnum"',
          "& th": { textAlign: "right", color: BRAND.textSecondary, fontSize: 11, fontWeight: 800, letterSpacing: "0.12em", textTransform: "uppercase", py: 1, px: 1, borderBottom: "1px solid rgba(255,255,255,0.12)" },
          "& td": { textAlign: "right", py: 0.9, px: 1, borderBottom: "1px solid rgba(255,255,255,0.06)", color: "#d7dae3", fontSize: 14.5, whiteSpace: "nowrap" },
          "& th:first-of-type, & td:first-of-type": { textAlign: "left", pl: 0, color: "#fff", fontWeight: 700 },
          "& td a": { color: "#fff", textDecoration: "none" },
          "& td a:hover": { color: BRAND.cyan },
        }}
      >
        <thead>
          <tr>
            {head.map((h) => (
              <th key={h}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i}>
              {r.map((v, j) => (
                <td key={j}>{typeof v === "number" ? v.toLocaleString() : v}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </Box>
    </Box>
  );
}
